import React from 'react';
import { MenuLayout } from '../../../themes/SwitchTheme';
import MissionCenter from './MissionCenter';

const MissionCenterPage: React.FC = () => {
  return (
    <MenuLayout>
      <MissionCenter />
    </MenuLayout>
  );
};

export default MissionCenterPage;